import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, message, FormInstance } from 'antd';

import { useOwnerDetails } from 'api/owners';
import { lodgifyApi } from 'api/partners';
import { Spin, Typography, Modal, InputUIKit } from 'ui-kit';

import './PartnerConnect.scss';
import { useSignedUser } from 'api/auth';

LodgifyConnect.propTypes = {
  visible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default function LodgifyConnect({ visible, onSubmit, onClose }) {
  const { data: user } = useSignedUser();
  const { invalidate } = useOwnerDetails(user?.owner_id);
  const [formDetails, setFormDetails] = useState({ apiKey: '' });
  const [isLoading, setLoading] = useState(false);

  const formRef = useRef<FormInstance | null>(null);

  const handleSubmit = () => {
    formRef.current.validateFields().then((values) => {
      setLoading(true);
      lodgifyApi.createOauth({ apiKey: values.apiKey }).then((res) => {
        if (res.ok) {
          message.success('API key saved successfully!');
          setFormDetails({ apiKey: values.apiKey });
          invalidate();
          onSubmit();
          setLoading(false);
        } else {
          message.error(res.data || 'Error adding API key!');
        }
      });
    });
  };

  return (
    <Modal
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Submit"
      okButtonProps={{ disabled: isLoading }}
      cancelButtonProps={{ hidden: true, disabled: true }}
    >
      <Spin spinning={isLoading}>
        <Typography variant="body1">Add your Lodgify API key here:</Typography>

        <Form ref={formRef} layout="vertical" initialValues={formDetails}>
          <div>
            <Form.Item
              name="apiKey"
              rules={[
                {
                  required: true,
                  message: 'Please input your API Key',
                },
              ]}
            >
              <InputUIKit placeholder="API Key" />
            </Form.Item>
          </div>
        </Form>
        <Typography variant="caption">
          Don’t have API key yet? Head over to your{' '}
          <a
            href="https://app.lodgify.com/marketplace/the-host-co"
            target="_blank"
            rel="noreferrer"
            className="Integration_external_link"
          >
            Lodgify Public API page
          </a>{' '}
          and scroll down until you see &quot;Copy Lodgify API key&quot;.
        </Typography>
      </Spin>
    </Modal>
  );
}
